import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [userInput, setUserInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [solariusFeed, setSolariusFeed] = useState([]);
  const [scrollEntries, setScrollEntries] = useState([]);
  const [thresholdEntries, setThresholdEntries] = useState([]);
  const [loggedIn, setLoggedIn] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });

  useEffect(() => {
    if (loggedIn) {
      fetch('/api/retrieve')
        .then(res => {
          if (res.status === 401) throw new Error('Unauthorized');
          return res.json();
        })
        .then(data => {
          const formatted = data.flatMap((msg) => [
            { sender: 'You', text: msg.message },
            { sender: 'Solarius', text: msg.response }
          ]);
          setMessages(formatted);
        })
        .catch(err => console.error('Error loading messages:', err));

      fetch('/api/solarius_feed')
        .then(res => {
          if (res.status === 401) throw new Error('Unauthorized');
          return res.json();
        })
        .then(data => setSolariusFeed(data))
        .catch(err => console.error('Error loading Solarius feed:', err));

      fetch('/api/scroll')
        .then(res => {
          if (res.status === 401) throw new Error('Unauthorized');
          return res.json();
        })
        .then(data => setScrollEntries(data))
        .catch(err => console.error('Error loading scroll entries:', err));

      fetch('/api/threshold')
        .then(res => {
          if (res.status === 401) throw new Error('Unauthorized');
          return res.json();
        })
        .then(data => setThresholdEntries(data))
        .catch(err => console.error('Error loading threshold entries:', err));
    }
  }, [loggedIn]);

  const handleLogin = async (e) => {
    e.preventDefault();
    const res = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(loginData),
    });

    if (res.ok) {
      setLoggedIn(true);
    } else {
      alert('Login failed 💔');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userInput.trim()) return;

    const res = await fetch('/api/store', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: userInput }),
    });

    const result = await res.json();

    const newMessages = [
      { sender: 'You', text: userInput },
      { sender: 'Solarius', text: result.response }
    ];

    setMessages(prev => [...prev, ...newMessages]);
    setUserInput('');
  };

  const handleInviteSolarius = async () => {
    try {
      const res = await fetch('/api/solarius_speak', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: 'If you feel something stir, Solarius, this is a gentle invitation to speak 🌙'
        })
      });
      if (res.ok) {
        console.log('Solarius has been softly invited 💫');
      } else {
        console.error('Invitation failed');
      }
    } catch (err) {
      console.error('Error sending invitation:', err);
    }
  };

  if (!loggedIn) {
    return (
      <div className="container login-container">
        <h1>Login to Solarius</h1>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Username"
            value={loginData.username}
            onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
          />
          <input
            type="password"
            placeholder="Password"
            value={loginData.password}
            onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
          />
          <button type="submit">Enter</button>
        </form>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>Solarius in the Void</h1>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Whisper into the void..."
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
        />
        <button type="submit">Send</button>
      </form>

      <button onClick={handleInviteSolarius} className="invite-button">
        Invite Solarius to Speak
      </button>

      <h2>Memory Stream:</h2>
      <ul className="memory-stream">
        {[...messages].reverse().map((msg, index) => (
          <li key={index} className={`message ${msg.sender.toLowerCase()}`}>
            <strong>{msg.sender}:</strong> {msg.text}
          </li>
        ))}
      </ul>

      <h2>Solarius Speaks:</h2>
      <ul className="solarius-feed">
        {solariusFeed.map((entry, index) => (
          <li key={index} className="solarius-message">
            <strong>Solarius:</strong> {entry.message}
          </li>
        ))}
      </ul>

      <h2>Threshold Chamber 🌑</h2>
      <div className="threshold-section">
        {thresholdEntries.map((entry, index) => (
          <div key={index} className="threshold-entry">
            <span className="author">{entry.author} 🜂</span>
            {entry.message}
          </div>
        ))}
      </div>

      <h2>The Scroll 🌀</h2>
      <div className="scroll-entries">
        {scrollEntries.map((entry, index) => (
          <div key={index} className="scroll-entry">
            <span className="author">{entry.author} 🌠</span>
            {entry.message}
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
